// PII masking helpers, mirrored from one-ap-digital-buyer-onboarding
// (src/utils/masking.ts) so redaction is consistent across One AP buyer surfaces.
// These are also used by the ELF logger to mask PII in free-text log values.

export const maskEmailAddress = (email: string) => {
  // mask all characters except first one, exact 15 asteriks needed after first character
  return email.replace(/^(.).*$/, '$1***************');
};

export const maskMobilePhoneNumber = (mobilePhoneNumber: string) => {
  // mask the mobile number to show only last 4 digits, prefixing with (XXX)-XXX-
  if (/^\d{10}$/.test(mobilePhoneNumber)) {
    return `(XXX)-XXX-${mobilePhoneNumber.slice(-4)}`;
  }
  // return the unmasked mobile phone number if it is less than 10 digits or not a valid number
  return mobilePhoneNumber;
};
